<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddRGBStandAloneTurnOn-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddRGBStandAloneTurnOn-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="AddHub-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
             <path class="AddHub-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91s2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91s-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
           </g>
           <g transform="translate(-35.411 67.908)">
             <path class="AddHub-st2" d="M79.76-9.52c0.01,4.4,3.57,7.97,7.97,7.97h1.43v12.93c0,3.53,5.16,3.53,5.16,0V-1.55h1.43c4.4,0,7.97-3.57,7.97-7.97v-5.67H79.76L79.76-9.52L79.76-9.52z"/>
              <path class="AddHub-st2" d="M104.58-24.59h-6.02v-9.47c0-1.42-1.15-2.58-2.58-2.58c-1.42,0-2.58,1.15-2.58,2.58v9.47h-3.32v-9.47c0-1.42-1.15-2.58-2.58-2.58c-1.42,0-2.58,1.15-2.58,2.58v9.47H78.9c-1.42,0-2.58,1.15-2.58,2.58s1.15,2.58,2.58,2.58h25.68c1.42,0,2.58-1.15,2.58-2.58S106.01-24.59,104.58-24.59L104.58-24.59z"/>
            </g>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.AddRGBStandAloneTurnOn_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.AddRGBStandAloneTurnOn_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="AddRGBStandAloneTurnOn-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" :iconRightPadding="8" :useLanguageDirection="true" textColor="#FFFFFF">
        {{$store.getters.language.texts.AddRGBStandAloneTurnOn_button}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'


export default {
  name: 'AddRGBStandAloneTurnOn',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    next: function () {
      this.$router.push('AddRGBStandAlone-LedCheck');
    }
  }
}
</script>

<style>
  .AddRGBStandAloneTurnOn-topCurve-wrapper {
    height: 200px;
  }
  .AddRGBStandAloneTurnOn-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .AddRGBStandAloneTurnOn-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.AddHub-st0 {
    fill: #ECECEC;
  }
	.AddHub-st1 {
    fill: #53636C;
  }
	.AddHub-st2 {
    fill: #1EA5DE;
  }
</style>
